import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { ArtistPortalOverviewResponse } from 'fym-shared/src/smartlinks/artistPortals';
import { musicServicesByMusicAPIID } from 'fym-shared/src/music-services/allMusicServices';
import { MusicAPIIntegrationID } from 'fym-shared/src/music-services/ids';
import { TypedMemo } from '../../common/types';
import { HomeKpiTile } from './HomeKpiTile';
import { artistHomeMessages as messages } from './artistHomeMessages';
import { streamsExtraTiles } from './audienceTiles';

interface StreamsExtraTilesProps {
  overview: ArtistPortalOverviewResponse | undefined;
  onOpenInsights: () => void;
}

/** The Apple Music for Artists Shazams and radio spins tiles of the Streams row. */
const StreamsExtraTilesComponent: React.FC<StreamsExtraTilesProps> = ({ overview, onOpenInsights }) => {
  const intl = useIntl();
  const tiles = useMemo(() => streamsExtraTiles(overview), [overview]);
  const appleMusic = musicServicesByMusicAPIID[MusicAPIIntegrationID.AppleMusic];

  return (
    <>
      {tiles.map((tile) => (
        <HomeKpiTile
          key={tile.kind}
          label={intl.formatMessage(tile.kind === 'shazams' ? messages.kpiShazams : messages.kpiRadioSpins)}
          dotColor={appleMusic?.color.primary}
          value={tile.value}
          delta={{ kind: 'none' }}
          source={appleMusic?.name}
          onOpen={onOpenInsights}
        />
      ))}
    </>
  );
};

export const StreamsExtraTiles = TypedMemo(StreamsExtraTilesComponent);
